<template>
  <div id="warpping" style="width: 100%;height:100%;overflow: hidden;">
    <!--头部 logo -->
    <curnav v-on:MainPageChanged="MainPageChanged"></curnav>
    <div class="manage_box">


      <div id="content" :class="[MainPageContentCss]">
        <transition>
          <router-view v-on:MainPageChanged="MainPageChanged"></router-view>
        </transition>
      </div>
    </div>

  </div>
</template>
<script>
import $ from "jquery";
import net from "../assets/js/public";
export default {
  data() {
    return {
      MainPageContentCss: 'MainPageContent1',

      nav_list: [
        {
          icon: "iconfont icon-dingdan",
          id: 1,
          menuName: "检测数据管理",
          roleId: 2,
          routeName: "/testDataManage",
          subMenu: [
            { id: 10, roleId: 2, menuId: 2001, menuName: "部位分组管理", subRouteName: "/positionGroup", subType: 0 },
            { id: 11, roleId: 2, menuId: 2001, menuName: "车辆检测数据", subRouteName: "/dossierManager", subType: 0 },
            { id: 12, roleId: 2, menuId: 2001, menuName: "进站台次", subRouteName: "/inCarManage", subType: 0 },
          ],
          type: 0,
          show: false,
          index:'1',
        },
        {
          icon: "iconfont icon-dingdan",
          id: 2,
          menuName: "人员账号管理",
          roleId: 2,
          routeName: "/accountManage",
          subMenu: [
            { id: 101, roleId: 2, menuId: 2001, menuName: "管理人员", subRouteName: "/leaderManage", subType: 0 },
            { id: 102, roleId: 2, menuId: 2001, menuName: "检测技师", subRouteName: "/workerManage", subType: 0 },
            { id: 103, roleId: 2, menuId: 2001, menuName: "服务顾问", subRouteName: "/saManage", subType: 0 },
            { id: 104, roleId: 2, menuId: 2001, menuName: "配件员", subRouteName: "/partsUserManage", subType: 0 },
            { id: 105, roleId: 2, menuId: 2001, menuName: "绑定管理", subRouteName: "/trussManage", subType: 0 },
            { id: 106, roleId: 2, menuId: 2001, menuName: "设备授权", subRouteName: "/deviceAuthList", subType: 0 },
          ],
          type: 0,
          show: false,
          index:'2',
        },
        {
          icon: "iconfont icon-dingdan",
          id: 3,
          menuName: "配件工时管理",
          roleId: 2,
          routeName: "/dataManage",
          subMenu: [
            { id: 201, roleId: 2, menuId: 1001, menuName: "配件", subRouteName: "/partsList", subType: 0 },
            { id: 202, roleId: 2, menuId: 1001, menuName: "工时", subRouteName: "/workHoursList", subType: 0 },
          ],
          type: 0,
          show: false,
          index:'3',
        },

        {
          icon: "iconfont icon-dingdan",
          id: 4,
          menuName: "全车影像检测",
          roleId: 2,
          routeName: "/vehicleInspectionAnalysis",
          subMenu: [
            { id: 301, roleId: 2, menuId: 1001, menuName: "运营统计", subRouteName: "/businessIntelligence", subType: 0 },
            { id: 302, roleId: 2, menuId: 1001, menuName: "检测报表", subRouteName: "/dailyTestAndDeal", subType: 0 },
            { id: 303, roleId: 2, menuId: 1001, menuName: "图表分析", subRouteName: "/dailyTestAndDealChart", subType: 0 },
            { id: 304, roleId: 2, menuId: 1001, menuName: "趋势报表", subRouteName: "/trendLineChart", subType: 0 },
            { id: 305, roleId: 2, menuId: 1001, menuName: "报告访问分析", subRouteName: "/dossierRequestLogSys", subType: 0 },
          ],
          type: 0,
          show: false,
          index:'4',
        },
      ],
    };
  },
  created() {

  },
  mounted() {
    let showInfo = JSON.parse(sessionStorage.getItem("showInfo"));
    if(showInfo && showInfo.showMenu){
      this.MainPageContentCss = 'MainPageContent2'
    }else {
      this.MainPageContentCss = 'MainPageContent1'
    }

  },
  methods: {
    MainPageChanged(pageType) {
      if (pageType == 1 || pageType == 0) {
        this.MainPageContentCss = 'MainPageContent1'
      } else {
        this.MainPageContentCss = 'MainPageContent2'
      }
    },

  },
  components: {
    curnav: resolve => {
      require(["../components/indexnav"], resolve);
    }
  }
};
</script>
<style lang="less" scoped>
#warping {
  width: 100%;
  overflow: hidden;
}
.manage_box {
  width: calc(100% - 80px);
  height: 100%;
  position: absolute;
  left: 80px;
}

#content {
  width: 100%;
  background: #F5F8FF;
}

.MainPageContent1 {
  box-sizing: border-box;
  /*padding: 60px 10px 10px 24px;*/
  width: calc(100% - 80px);
  height: 100%;
  overflow: auto;
}

.MainPageContent2 {
  /* position: absolute;
  top: 70px;
  left: 240px; */
  box-sizing: border-box;
  padding: 60px 24px 10px 200px;
  width: calc(100% - 348px);
  height: 100%;
  overflow: auto;
}

#content::-webkit-scrollbar-y {
  display: none;
}
</style>

<style lang="less" >
  /deep/ .table_header {
    background: #F3F7FB !important;
    color: #364556;
  }
  /deep/ .el-table th.el-table__cell {
    background: #F3F7FB !important;
    color: #364556;
  }
  .el-input--prefix .el-input__inner{
    padding-left: 10px;
  }
  .el-input__prefix {
    left: 135px;
  }


  .el-drawer__header {
    text-align: left;
}
  a {
    text-decoration: none;
    cursor:pointer;
  }
.position_box_btn {
      position: absolute;
      bottom: 24px;
      right: 24px;
  display: flex;
      .sure_btn {
        width: 104px;
        height: 36px;
        display: block;
        line-height: 36px;
        background: #2B54FC;
        box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
        border-radius: 4px;

        font-size: 14px;
        text-align: center;
        color: #FFFFFF;
        margin-right: 8px;

      }
      .cancel_btn {
        width: 76px;
        height: 36px;
        display: block;
        line-height: 36px;
        background: rgba(148, 170, 204, 0.08);
        border: 1px solid #E3E7ED;
        border-radius: 4px;
        font-size: 14px;
        text-align: center;
        color: #364556;
      }
    }

.pagination {
  position: relative;
  margin-top: 10px;
  height: 36px;

  .el-pagination {
    position: absolute;
    right: 0px;

    .el-pager li:not(.disabled) {
      .active {
        background: #009688 !important;
      }
    }
  }
}

  .el-message {
    min-width: 120px;
    height: 40px;
    top: 50%;
  }
  .el-message--success{
    background: #E8FFEA;
    box-shadow: 0px 2px 12px rgba(127, 133, 154, 0.16);
    border-radius: 4px;
  }
  .el-message--success .el-message__content{
    color: #0D0E12;
  }


  .datepicker {
    /deep/.el-input__inner {
      padding-left: 15px;
    }
  }
  .select_day {
    position: relative;
    width: 100%;
    width: fit-content;
    .el-icon-date {
      position: absolute;
      top: 30%;
      right: 10px;
      z-index: 9;
      color: #c0c4cc;
      font-size: 14px;
      transform: translateY(-50%);
    }
    /deep/ .el-range__close-icon {
      position: absolute;
      right: 34px;
      top: 54%;
      transform: translateY(-50%);
    }
  }
  .search_day_list{
    position: relative;
    width: 100%;
    width: fit-content;
    .el-icon-date {
      position: absolute;
      top: 50%;
      right: 10px;
      z-index: 9;
      color: #c0c4cc;
      font-size: 14px;
      transform: translateY(-50%);
    }
    /deep/ .el-range__close-icon {
      position: absolute;
      right: 34px;
      top: 54%;
      transform: translateY(-50%);
    }
  }

  .el-tabs__item {
    -webkit-user-select:none;
    -moz-user-select:none;
    -ms-user-select:none;
    user-select:none;
  }


</style>
